import { type ReadFieldFunction } from '@apollo/client/cache/core/types/common';
import { createDate } from '@lingoda/dates';
import {
    type AppointmentsListQueryVariables,
    mergeTimelineHashList,
    readTimelineHashList,
} from '@lingoda/monolith-graphql';
import type { FieldPolicy, Reference } from '@apollo/client';

export const appointmentsList: FieldPolicy = {
    merge(existing, incoming, { args, readField, field }) {
        const alias = field?.alias?.value ?? 'appointmentsList';
        const existingHash: Record<string, Record<string, Reference>> = existing ?? {};
        const incomingList = incoming as Reference[];
        const getItemId = (item: Reference) => readField('id', item) as string;

        return mergeTimelineHashList(
            existingHash,
            incomingList,
            args as AppointmentsListQueryVariables,
            { getItemId },
            alias,
        );
    },
    read(existingHash, { args, readField, field }) {
        if (!existingHash) {
            return undefined;
        }

        const cacheKey = field?.alias?.value ?? 'appointmentsList';

        const getTimestamp = getStartTimestamp(readField);

        return readTimelineHashList(
            existingHash as Record<string, Record<string, Reference>>,
            args as AppointmentsListQueryVariables,
            { getTimestamp },
            cacheKey,
        );
    },
};

const getStartTimestamp = (readField: ReadFieldFunction) => (appointment: Reference) => {
    return createDate(readField('startDate', readField('class', appointment))).getTime();
};
